import type { DataOption } from '@/entities/column'
import type {
	CompetitorModel,
	CompetitorsResponseModel,
} from '@/shared/generated'

const competitorToOption = ({ name }: CompetitorModel): DataOption => ({
	label: name!,
	value: name!,
})
export const selectCompetitorsAsOptions = ({
	objects,
}: CompetitorsResponseModel) => objects?.map(competitorToOption) || []
